import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { StorageService } from '../services/storage/storage.service';

/**
 * A guard that checks if the app has been set up and the cgu accepted.
 * @param {StorageService} _storage - The storage service.
 * @param {Router} router - The router.
 * @returns {Observable<boolean> | boolean} - An observable that emits true if the app has been set up and the cgu accepted.
 */
@Injectable({providedIn: 'root'})
export class AppSetUpGuard  {
    constructor(private _storage: StorageService, public router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
      return this._storage.setUpApp().pipe(
        map((contact) => {
          if (!contact || !contact.cguAcceptanceDate) {
            this.router.navigateByUrl('/connected');
            return false;
          }
          return true;
        })
      )
    }
}
